module.exports = "<div class=\"offset-xl-1 display-4\">\n    <span class=\"component-title\">Geometría</span>\n</div>\n<ng-container warehouse-params-form></ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/project/project-form-components/warehouse-params-forms/warehouse-params-form-selector/warehouse-params-form-selector.component.html
// module id = 775
// module chunks = 0